// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uucp","field":"styles_field__swHkb","fieldCol":"styles_fieldCol__13Auj","diffCol":"styles_diffCol__GC-iq","diff":"styles_diff__1L9Tb"};